const questionsService = {
    async get(data) {
        const apiURL = process.env.REACT_APP_API + '/simulated/questions';
        const token = localStorage.getItem('token') ?? null;

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        return await fetch(apiURL, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data)
        })
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            } else {
                return response.json();
            }
        })
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
    },
    async answer(data) {
        const apiURL = process.env.REACT_APP_API + '/simulated/answer';
        const token = localStorage.getItem('token') ?? null;

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        return await fetch(apiURL, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data)
        })
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            } else {
                return response.json();
            }
        })
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
    }
}

export default questionsService;
